module.exports = __webpack_public_path__ + "media/public/images/contacts/head-f1dfa7eb0e7196e1302b2eb7c2db11b7.jpg";